<template>
    <div>
        <div class="mb-6">
            <h1 class="text-2xl font-bold text-gray-900 text-center">
                {{ isEditMode ? 'Edit property' : 'Add Property Details' }}
            </h1>
        </div>

        <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:items-stretch">
            <div class="lg:col-span-2">
                <div class="bg-white rounded-lg shadow-lg p-5">
                    <jet-validation-errors class="mb-3" />

                    <PropertyDetailsStep
                        :form="form"
                        :autocompleteRef="autocompleteRef"
                        :initAutocomplete="initAutocomplete"
                        :propertyStructureTypes="propertyStructureTypes"
                        :screening-fee-amount="screeningFeeAmount"
                        :show-application-fee-section="showApplicationFeeSection"
                        :has-payment-method="hasPaymentMethod"
                        :has-stripe-setup="hasStripeSetup"
                        :payment-method-success="paymentMethodSuccess"
                    />
                </div>
            </div>

            <div class="lg:col-span-1 lg:flex lg:flex-col">
                <PropertySummaryCard
                    class="lg:flex-1"
                    :form="form"
                    :formatNumber="formatNumber"
                    :property="property"
                    :hide-image="isEditMode"
                >
                    <template #footer>
                        <button
                            type="button"
                            @click="submit"
                            :disabled="form.processing"
                            class="flex w-full items-center justify-center gap-2 rounded-md px-6 py-2.5 text-sm font-semibold text-white theme_color hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            <span
                                v-if="form.processing"
                                class="inline-block h-4 w-4 animate-spin rounded-full border-b-2 border-white"
                            />
                            <span v-else>{{ isEditMode ? 'Save changes' : 'Add Property' }}</span>
                            <font-awesome-icon v-if="!form.processing" :icon="faCheck" class="h-4 w-4" />
                        </button>
                    </template>
                </PropertySummaryCard>
            </div>
        </div>

    </div>
</template>

<script setup>
// 86bcd9hg3 (decision 17): a new property is always tenant screening only; what else it
// gets comes from the account's plan, so there is no per-property choice or billing
// agreement here any more.
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import JetValidationErrors from '@/Jetstream/ValidationErrorsWithHtml.vue'
import PropertyDetailsStep from './Steps/PropertyDetailsStep.vue'
import PropertySummaryCard from './PropertySummaryCard.vue'

defineProps({
    form: {
        type: Object,
        required: true,
    },
    autocompleteRef: {
        type: Object,
        required: true,
    },
    initAutocomplete: {
        type: Function,
        required: true,
    },
    formatNumber: {
        type: Function,
        required: true,
    },
    propertyStructureTypes: {
        type: Object,
        required: true,
    },
    isEditMode: {
        type: Boolean,
        default: false,
    },
    property: {
        type: Object,
        default: null,
    },
    screeningFeeAmount: {
        type: Number,
        required: true,
    },
    showApplicationFeeSection: {
        type: Boolean,
        default: true,
    },
    hasPaymentMethod: {
        type: Boolean,
        default: false,
    },
    hasStripeSetup: {
        type: Boolean,
        default: false,
    },
    paymentMethodSuccess: {
        type: String,
        default: null,
    },
})

const emit = defineEmits(['submit'])

const submit = () => {
    emit('submit')
}
</script>
